/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.LabelDepartmentInfoRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/core/labelDepartmentInfo/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
